export default __webpack_public_path__ + "assets/4111464d1fb67c89c9301e00b57aae66.png";